import { useLayoutEffect } from 'react';

export function workspaceWindowTitle(jobName?: string): string {
  const name = (jobName ?? '')
    .replace(/[\u0000-\u001f\u007f]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return name ? `Paige - Job: ${name}` : 'Paige';
}

/** Only the primary App uses this hook. Detached windows keep their native
 * panel titles; no privileged renderer window API is needed. */
export function useWorkspaceWindowTitle(jobName?: string) {
  const title = workspaceWindowTitle(jobName);
  useLayoutEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      if (document.title === title) document.title = previous;
    };
  }, [title]);
}
